import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = {
  key: 1,
  class: "title"
}
const _hoisted_3 = { class: "row items-center q-col-gutter-md" }
const _hoisted_4 = { class: "col-4" }
const _hoisted_5 = {
  key: 0,
  class: "new-packing-tag"
}
const _hoisted_6 = {
  key: 1,
  class: "card-title"
}
const _hoisted_7 = {
  key: 2,
  class: "placeholder"
}
const _hoisted_8 = { class: "col-2" }
const _hoisted_9 = { class: "col-2" }
const _hoisted_10 = { class: "col-2" }
const _hoisted_11 = {
  key: 0,
  class: "col-2"
}
const _hoisted_12 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_editable_block_dimension_input = _resolveComponent("editable-block-dimension-input")!
  const _component_form_select = _resolveComponent("form-select")!
  const _component_tick_icon = _resolveComponent("tick-icon")!
  const _component_pen_icon = _resolveComponent("pen-icon")!
  const _component_trash_icon = _resolveComponent("trash-icon")!
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_d_button = _resolveComponent("d-button")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    class: "create-packing-group",
    "model-value": _ctx.showCreatePackingGroup,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (!$event ? _ctx.$emit('close') : null))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              (!_ctx.categoryId)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_1, "Create a packaging group"))
                : (_openBlock(), _createElementBlock("h5", _hoisted_2, "Modify packaging group")),
              _cache[3] || (_cache[3] = _createElementVNode("p", null, "Every type of packaging gets its own package group. Within this group you can add the possible sizes. According to a stock item’s size Directify will calculate the right package size.", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_form_input, {
                label: "Group name",
                type: "text",
                "model-value": _ctx.editState.category.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.editState.category.name = $event?.toString()))
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editState.categoryPackings, (packing, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "packing-size",
                  key: packing.sys.id
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      (packing.editing)
                        ? (_openBlock(), _createBlock(_component_q_select, {
                            key: 0,
                            "model-value": packing.name,
                            "display-value": packing.name,
                            options: _ctx.filteredPackingOptions,
                            "onUpdate:modelValue": ($event: any) => (_ctx.updatePackingGroup(index, $event)),
                            onNewValue: ($event: any) => (_ctx.createNewPacking(index, $event)),
                            onFilter: _ctx.filterFn,
                            "popup-content-style": "padding: 0;",
                            label: "Size name",
                            "popup-content-class": "select",
                            "hide-selected": "",
                            "fill-input": "",
                            "use-input": "",
                            dense: ""
                          }, {
                            append: _withCtx(() => [
                              (packing.name.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "new"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["model-value", "display-value", "options", "onUpdate:modelValue", "onNewValue", "onFilter"]))
                        : (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(packing.name), 1)),
                      (packing.editing)
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_7, "Press Enter to create new Packing", 512)), [
                            [_vShow, _ctx.filteredPackingOptions?.length <= 0]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_editable_block_dimension_input, {
                        "model-value": packing.dimensions?.x ? packing.dimensions?.x : 1,
                        "onUpdate:modelValue": ($event: any) => (packing.dimensions = { ...packing.dimensions, x: $event }),
                        append: packing.dimensions?.unit ? packing.dimensions.unit : 'cm',
                        editing: packing.editing,
                        label: "L"
                      }, null, 8, ["model-value", "onUpdate:modelValue", "append", "editing"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_editable_block_dimension_input, {
                        "model-value": packing.dimensions?.z ? packing.dimensions?.z : 1,
                        "onUpdate:modelValue": ($event: any) => (packing.dimensions = { ...packing.dimensions, z: $event }),
                        append: packing.dimensions?.unit ? packing.dimensions.unit : 'cm',
                        editing: packing.editing,
                        label: "W"
                      }, null, 8, ["model-value", "onUpdate:modelValue", "append", "editing"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_editable_block_dimension_input, {
                        "model-value": packing.dimensions?.y ? packing.dimensions?.y : 1,
                        "onUpdate:modelValue": ($event: any) => (packing.dimensions = { ...packing.dimensions, y: $event }),
                        append: packing.dimensions?.unit ? packing.dimensions.unit : 'cm',
                        editing: packing.editing,
                        label: "H"
                      }, null, 8, ["model-value", "onUpdate:modelValue", "append", "editing"])
                    ]),
                    (packing.editing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_form_select, {
                            "model-value": packing.dimensions?.unit,
                            "onUpdate:modelValue": ($event: any) => (packing.dimensions = { ...packing.dimensions, unit: $event}),
                            placeholder: packing.dimensions?.unit ? packing.dimensions.unit : 'cm',
                            options: _ctx.units,
                            type: "select",
                            borderless: ""
                          }, null, 8, ["model-value", "onUpdate:modelValue", "placeholder", "options"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      (packing.editing)
                        ? (_openBlock(), _createBlock(_component_tick_icon, {
                            key: 0,
                            size: "20px",
                            onClick: ($event: any) => (_ctx.confirmPacking(index))
                          }, null, 8, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_pen_icon, {
                            key: 1,
                            size: "20px",
                            onClick: ($event: any) => (_ctx.editPacking(index))
                          }, null, 8, ["onClick"])),
                      _createVNode(_component_trash_icon, {
                        size: "20px",
                        onClick: ($event: any) => (_ctx.removePacking(index))
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ]))
              }), 128)),
              _createVNode(_component_d_button, {
                class: "add-packing",
                onClick: _ctx.addPackingSize,
                flat: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_add_icon, { size: "20px" }),
                  _cache[4] || (_cache[4] = _createElementVNode("span", null, "Package size", -1))
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                class: "q-mr-md",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                unelevated: "",
                rounded: ""
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_close_icon, { left: "" }, null, 512), [
                    [_directive_close_popup]
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "Cancel", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_q_btn, {
                onClick: _ctx.savePackingGroup,
                unelevated: "",
                rounded: "",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_tick_icon, { left: "" }),
                  _cache[6] || (_cache[6] = _createElementVNode("span", null, "Save", -1))
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}